import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListEstablishmentUser = (props) => {
  const { displayOptions } = props;

  const { attributes, actions, listEstablishmentUser, findAllEstablishmentUsers, totalPages, loading, query } =
    useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t('establishment-user.title.list')}
            subtitle={t('establishment-user.subTitle')}
            className="text-sm-left"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listEstablishmentUser}
                loading={loading}
                search={findAllEstablishmentUsers}
                numberOfPage={totalPages}
                query={query}
                textButton={displayOptions.addButton && t('establishment-user.add')}
                linkButton={displayOptions.addButton && '/establishment-user/add'}
                pdfTitle="Liste des administrateurs établissements"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListEstablishmentUser;
